  /* 国际化zh_tw */

module.exports = {
    base:{
        "nomore" : "Не больше", //沒有更多了
        "sure" : "Определять", //确定
        "not_desc" : "Пока нет описания", //暂无描述
    },
    common:{
        "get_code" : "Получить код подтверждения", //获取验证码
        "onsale_status" : "Tовар прекратил продажу", //该商品已下架
        "s_regain" : "S Получить снова после секунды", //
        "regain" : "Получить снова", //重新获取
        "cancel" : "Отмена", //取消
        "select" : "Выбрать", //选取
        "empty_item" : "Пока нет содержания", //暂无内容
        "load_fail" : "Загрузка не удалась", //加载失败
        "tabbar_my_name" : "Мой", //
    },
    tabbar:{
        "home" : "Начало", //首页
        "category" : "Категория", //分类
        "cart" : "Корзина", //购物车
        "profile" : "Мой", //我的
        "service" : "skype", //客服
    },
    address:{
        "name" : "Имя получателя", //
        "name_placeholder" : "Заполните реальное имя получателя", //
        "mobile" : "Мобильный номер ", //
        "mobile_placeholder" : "личный мобильный телефон", //
        "email" : "Email",
		"email_placeholder" : "Введите электронную почту!",
        "region" : "Область города", //
        "region_placeholder" : "Город, район, улица", //
        "address" : "Подробный адрес", //
        "address_placeholder" : "Заполните подробный адрес", //
        "zip" : "Почтовый индекс", //
        "zip_placeholder" : "Заполните правильный почтовый индекс", //
        "name_empty" : "Заполните имя получателя", //
        "name_less" : "Ограничение 2-50 букв", //
        "mobile_empty" : "Заполните мобильный номер", //
        "mobile_less" : "Заполните мобильный номер правильного формата", //
        "region_empty" : "Выберите область города", //
        "address_empty" : "(на английском языке)Заполните подробный адрес", //
        "zip_empty" : "Заполните почтовый индекс", //
        "save_use" : "Сохранить и использовать", //
        "save" : "Сохранить", //
        "add" : "Адрес добавления", //
        "edit" : "Изменить адрес доставки", //
        "delete" : "Удаление", //
        "list_title" : "Адрес доставки", //
        "list_title_item" : "Управление", //
        "default" : "Молчание", //
        "list_default" : "Адрес по умолчанию", //
        "list_edit" : "Редакция", //
        "list_delete" : "Удаление", //
        "manage_title" : "Управление адресом доставки", //
        "manage_empty" : "Адрес доставки не добавляете!", //
        "manage_add" : "Добавляйте адрес доставки", //
        "confirm_del" : "Подтвердите, что хотите удалить адрес доставки?", //
        "confirm_del_title" : "Удаление подтверждения", //
        "region_select" : "Выберите регион", //
        "region_cancel" : "Отмена", //
        "region_confirm" : "Определять ", //
    },
    auth:{
        "retrieve" : "Восстановление пароля", //密码找回
        "mobile" : "Мобильный номер", //
        "email" : "E-mail", //
        "go_signin" : "Идти в логин", //
        "sure" : "Определять", //
        "signin" : "Логин", //登录
        "signup" : "Регистрация", //注册
        "fast_signup" : "Регистрация", //快速注册
        "email_signup" : "E-mail Регистрация", //
        "agree" : "Нажмите на регистрацию, чтобы согласиться", //
        "agreement" : "《Соглашение о пользователи》", //
        "signup_succ" : "Регистрировали успешно", //
        "signup_agreement" : "Соглашение о регистрации", //
    },
	auth_signin:{
		"username_placeholder" : "Имя пользователя／E-mail", //用户名/邮箱/手机号
		"password_placeholder" : "Введите пароль", //请输入密码
		"forget" : "Забыли пароль?", //忘记密码？
		"third_party" : "Логин третьей стороны", //
		"wechat" : "WeChat", //微信
		"passport_empty" : "Введите пароль", //请输入密码
		"passport_less" : "Введите пароли не менее 6 цифр", //至少输入6位密码
		"expire" : "Логин просрочил", //登录过期
		"username_empty" : "Введите имя пользователя", //请输入用户名
	},
	auth_bind:{
		"mobile" : "Привязка мобильного номера", //绑定手机
		"code_placeholder" : "Введите код подтверждения", //
		"username_placeholder" : "Введите код подтверждения мобильного телефона", //请输入手机号
		"passport_placeholder" : "Пароль установки", //设置密码
		"confirmPassword_placeholder" : "Подтвердите пароль", //确认密码
		"tips" : "6-20 цифр/букв/знаков", //
		"finish" : "Завершение", //完成
		"mobile_less" : "Введите номер телефона в правильном формате", //
		"code_empty" : "Введите код подтверждения", //
		"code_less" : "Введите шестизначный код подтверждения ", //
		"password_empty" : "Введите пароль", //
		"password_less" : "введите пароль из 6-20 знаков", //
		"confirmPassword_empty" : "Введите пароль подтверждения", //
		"passport_error" : "Пароль подтверждения не соответствует паролю входа", //
	},
	auth_email:{
		"confirm_tips" : "Ссылка для смены пароля была отправлена на", //密码修改链接已发送至
		"email_placeholder" : "Введите электронную почту!", //请输入您的邮箱
		"tips" : "Отправим ссылку для  изменения пароля на почтовый ящик привязки", //我们将发送密码修改链接到您绑定的邮箱
		"send" : "Отправить E-mail", //发送邮件
		"empty" : "Введите E-mail", //请输入邮箱
		"validator_error" : "Неверный E-mail", //邮箱地址不正确
		"username_placeholder" : "Имя пользователя", //用户名
		"username_tips" : "Имя пользователя состоит из 3-25 цифр, может включать английские языки и цифры", //
		"passport_tips" : "6-20 цифр/букв/знаков", //
		"signup_email_placeholder" : "E-mail", //邮箱地址
		"email_tips" : "Введите E-mail", //请输入邮箱地址
		"username_empty" : "Введите имя пользователя с знаком 3-25 шт.", //
		"password_empty" : "Введите пароль", //请输入密码
		"password_less" : "Введите пароль из 6-20 знаков", //
	},
    auth_mobile:{
        "retrieve_succ" : "Пароль был изменен успешно путем восстановления мобильного телефона "
    },
    balance:{
        "usable_title" : "Располагаемые средства", //
        "desc" : "Располагаемые средства（$）", //
        "withdraw" : "Снятие со счета", //
        "withdraw_history" : "Запись снятия со счета", // //
        "withdraw_show" : "Просмотр ведомости средств", //
        "history_title" : "Ведомость средств", //
        "history_empty" : "Пока нет подробностей", //
        "history_all" : "Весь", //
        "history_income" : "Доход", //
        "history_expend" : "Расход", //
    },
    withdraw:{
        "history_title" : "Запись снятия со счета", //
        "history_empty" : "Пока нет записи", //
        "history_confirm" : "Отменить ли снятие со счета", //
        "history_confirm_title" : "Отмена подтверждения", //
        "title" : "Снятие со счета", //
        "succ_title" : "Заявка на снятие со счета была отправлена", //
        "succ_desc" : "Подождите, пока конторщик проверяет", //
        "amount" : "Сумма снятия со счета", //
        "remarks" : "Примечание", //
        "btn_finish" : "Завершение", //
        "subtitle" : "Сумма снятия со счета", //
        "tips" : "Превышать за пределы диапазона снятия со счета", //
        "mentioning_balances" : "Остаток снятия со счета $", //
        "all" : "Полное снятие со счета", //
        "remark_placeholder" : "Заполните название банка и номер банковской карты", //
        "btn_submit" : "Выдача", //
        "amount_empty" : "Заполните суммы снятия со счета", //
        "remark_empty" : "Заполните название банка и номер банковской карты", //
        "item_title" : "Примечание торговца", //
        "item_amount" : "Сумма снятия со счета", //
        "item_time" : "Время заявки", //
        "item_remark" : "Примечание члена", //
        "item_cancel" : "Снятие со счета отмены", //
        "wait" : "Обработка в ожидании", //
        "finish" : "Снятие со счета удалось", //
        "cancel" : "Отменял", //
        "failed" : "Снятие со счета не удалось", //
    },
    bonus:{
       "list_title" : "Моя рекомендация", //
       "recommended" : "Рекомендовал", //
       "amount" : "Вознаградил", //
       "rule" : "Правила вознаграждения", //
       "balance" : "Располагаемые средства", //
       "recommend" : "Член моей рекомендации", //
       "order_empty" : "Пока нет заказа рекомендации", //
       "recommend_rank" : "Уровень", //
       "recommend_amount" : "Число людей", //
       "recommend_score" : "Вознаграждения от балла", //
       "recommend_price" : "Вознаграждения от денежных средств", //
       "recommend_empty" : "Пока нет рекомендации", //
       "order_sn" : "Номер заказа", //
       "cash" : "Денежные средства", //
       "wait" : "В проверке", //
       "finish" : "Вознаградил", //
       "cancel" : "Отменял", //
       "revoke" : "Отменяли", //
       "type_signup" : "Вознаграждение регистрации рекомендации", //
       "type_order" : "Вознаграждение заказа рекомендации", //
       "score_signup" : "Балл уровня", //
       "score_order" : "Балл потребления", //
       "my_qrcode" : "Мой двухмерный код продвижения", //
       "qr_desc" : "Сканируйте двухмерный код и следуйте за моим интернат- магазином", //
       "qr_share" : "Интернат-магазин разделения", //
       "qr_copy" : "Скопировать ссылку", //
       "qr_share_title" : "Вознаграждение рекомендации", //
       "qr_share_desc" : "Нажмите на ссылку, чтобы обратите внимание на интернет- магазин. Стать человеком популяризации для получение еще больше баллов", //
       "qr_link" : "Ссылка популяризации была создана для вас", //
       "btn_confirm" : "Подтверждение", //
    },
    cart:{
        "title" : "Корзина", //购物车
        "edit" : "Редакция", //编辑
        "finish" : "Завершение", //完成
        "select_all" : "Выбрать все", //全选
        "total" : "Всего:", //合计
        "delete" : "Удаление", //删除
        "checkout" : "Расчет", //结算
        "empty" : "Корзина еще является пустой", //您的购物车还是空的
        "no_signup" : "Товар в корзине может осмотреть после логина", //登录后即可查看购物车中的商品
        "gohome" : "Просто гулять", //随便逛逛
        "gosignin" : "Идти в логин", //去登录
        "sold_out" : "Распродало", //已售罄
        "only_left" : "Осталось только", //仅剩
        "piece" : "шт", //件
        "promos_tag" : "Продвижение", //促销
        "delete_empty" : "Товар без возможной отмены", //当前没有可删除的商品
        "no_reduce" : "Хоть святых выноси, товар нельзя более меньше", //
        "out_of_stock" : "Общие складские запасы данного товара не хватают ", //
        "promos" : "Соответствие", //
        "un_promos" : "Льгота не соответствия", //
        "order_promos" : "Продвижение заказа", //
    },
    cashgift:{
        "list_title" : "Мой Купон", //Купон
        "list_empty" : "Пока нет Купон", //
        "unuse" : "Не используется", //
        "used" : "Использовался", //
        "expired" : "Просрочил", //
        "bonus_sn_placeholder" : "Введите серийный номер Купон", //
        "bonus_add" : "Добавление Купон", //
        "bonus_sn_empty" : "Введите 10-значный серийный номер", //
        "bonus_add_succ" : "Купон был добавлен успешно ", //
        "no_use_bonus" : "Не используйте Купон", //
        "full" : "Свыше", //
        "can_use" : "может использовать", //
    },
    coupon: {
		"list_title" : "我的优惠券",
		"list_empty" : "暂无优惠券",
		"full" : "满",
		"can_use" : "元可使用",
		"unuse" : "未使用",
		"used" : "已使用",
		"expired" : "已过期",
		"redbag_title" : "我的红包",
		"can_use_coupon" : "可使用优惠券",
		"no_use_coupon" : "不使用优惠券",
		"redbag_empty" : "暂无红包",
		"piece" : "张",
	},
    category:{
        "title" : "Категория", //分类
        "all" : "Весь", //全部
        "enter": 'войти',
		"column": 'столбец'
    },
    checkout:{
        "title" : "Заказ подтверждения", //
        "title_shipping" : "Способ доставки", //
        "title_invoice" : "Тип чека", //
        "title_cashgif" : "Используйте Купон", //
        "title_product_price" : "Сумма товара", //
        "title_tax_price" : "Ставка налога чека", //
        "title_shipping_price" : "Фрахт", //
        "total_price" : "Фактический платеж", //
        // "total_price_tips" : "( Цена не включает налог )", //
        "btn_checkout" : "Заказ отправки", //
        "shipping_empty" : "Выберите способ доставки", //
        "consignee_empty" : "Заполните адрес доставки", //
        "cashgift_unuse" : "Не используется", //
        "cashgift_nouse" : "Не располагаемый", //
        "cashgift_tips" : "1 лист был выбран ", //
        "cashgift_canuse" : "Располагаемый  лист", //
        "no_invoice" : "Не нужно счета", //
        "invoice_type_empty" : "Выберите тип чека", //
        "no_shipping_price" : "Бесплатный фрахт", //
        "goback_mess" : "Хорошие товары не ждут других </br> обдумайте перед действиями", //
        "goback_cancel_text" : "отходить", //
        "goback_confirm_text" : "Отмена", //
        "invoice_header" : "Информация о чеке установки", //
        "invoice_type_title" : "Тип чека", //
        "invoice_tips" : "Боитесь потерять свой бумажный счет? Попробуйте электронные счета!", //
        "invoice_title" : "Клиент чека", //
        "invoice_personal" : "Личность", //
        "invoice_content" : "Детали чека", //
        "invoice_btn_submit" : "Подтверждение", //
        "invoice_empty" : "Заполните информацию о чеке", //
        "shipping_price" : "Расходы доставки", //
        "goods_list_header" : "Список продуктов", //
        "total" : "Всего:", //
        "piece" : " шт.", //
        "score_header" : "Вычет балла", //
        "score_most" : "Максимум располагаемый ", //
        "score" : " Балл", //
        "deduct_from" : "Вычет из каждого балла $", //
        "rmb" : "доллар", //
        "no_score" : "Не располагаемый балл", //
        "score_placeholder" : "Введите балл здесь", //
        "delivery_time" : "Время доставки", //
        "comment_title" : "Записка покупателя", //
        "comment_placeholder" : "Заполните по выбору: объяснение к данной сделке (рекомендуется заполнить содержание, которое было согласовано с продавцом) ,Оставляйте записку о потребности заказа продукта здесь.", //
        "address_empty" : "Адрес доставки еще не имеете. Нажмите здесь, чтобы добавить его.", //
        "promos_preferential" : "Сумма скидки", //
        "promos_cashgift" : "Купон", //
        "promos_score" : "Балл", //
        "promos_order_reduction" : "Продвижение заказа", //
        "promos_goods_reduction" : "Продвижение товаров", //
        "promos_coupon_reduction" : "Купон", //
        "promos_combined_promos" : "Групповая покупка", //
        "promos_transport_title" : "Фрахт", //
        'tax_header': 'Налоговый номер', // 税号
        'tax_tips': 'Для облегчения таможенного оформления', // 税号为什么要填写
        'import_duty': 'Налоговая зарядка', // 进口关税
        'price_tips': '「 цена без налогов 」', //不含税价格!

        "coo": 'Требуется сертификат происхождения(COO)', //需要原产地证书
        "coo_fee": 'расходы по COO', //产地证书费用
        "yes": 'Да', //是
        "no": 'Нет' //否
    },
    payment:{
        "header" : "Расчетно–кассовый узел", //
        "order_succ" : "Заказ был отправлен успешно.  Выберите способ платежа", //
        "total_price" : "Всего", //
        "teegon_wechat" : "Оплата WeChat инкассации Tiangong", //
        "btn_pay" : "Немедленный платеж", //
        "goback_mess" : "Товар продался мгновенно </br> подтвердите, что хотите отказаться от платежа?", //
        "goback_cancel_text" : "отходить", //
        "goback_confirm_text" : "Отмена", //
        "code_empty" : "Выберите способ оплаты", //
        "succed_header" : "Купить успешно", //
        "order_succed" : "Заказ был отправлен успешно!", //
        "exchange_order_succed" : "Поздравляем, обменял успешно", //
        "order_detail" : "Подробность заказа", //
    },
    discount:{
        "header" : "Льготная деятельность", //
        "empty" : "Пока нет льготных действий", //
        "range_0" : "Все товары может использовать", //
        "range_1" : "Некоторые категории может использовать", //
        "range_2" : "Некоторые бренда может использовать", //
        "range_3" : "Некоторые товаров может использовать", //
        "range_canuse" : "Может использовать", //
        "is_end" : "Деятельность была закончена", //
        "waiting" : "Ожидайте",
        "is_waiting" : "Деятельность еще не началась", //
        "list_empty" : "Пока нет любых товаров", //
        "no_more" : "Не был больше",
        "review_rate" : "Хорошая оценка", //
        "sales_count" : "Оборот по продаже", //
        "surplus" : "Избыток", //
        "day" : "День", //
        "hour" : "Час", //
        "minute" : "Минут", //
        "second" : "Секунд", //
    },
    promotions:{
        "no_more" : "Не был больше",
        "endtime" : "Время до окончания деятельности",
        "day" : "День",
        "hour" : "Час",
        "minute" : "Минут",
        "second" : "Секунд",
    },
    home:{
        "goodproduct" : "Горячая рекомендация", //热门推荐
        "hotproduct" : "Рейтинг продаж", //销量排行
        "recentproduct" : "Новые поступления", //新品上架
		"suitproducts": "Комбинированный товар", //组合商品
		"header_placeholder" : "Что вы ищете?", //想找什么？
        "menu_activity" : "Льготная деятельность", //优惠活动
        "menu_integralmall" : "Интернет-магазин балла", //积分商城
        "menu_order" : "Заказ", //订单
        "menu_bonus" : "Купон", //红包
        "menu1": "Многороторный",
		"menu2": "Фиксированное крыло",
		"menu3": "FPV",
		"menu4": "Робота",
		"menu5": "T-DRONES",
        "product_buy" : "Приобрели люди", // 人已购买
        "share_title" : "Вознаграждение рекомендации", //
        "share_desc" : "Нажмите на ссылку, чтобы обратите внимание на интернет- магазин. Стать человеком популяризации для получение еще больше баллов", 
    },
    integralmall:{
        "header" : "Интернет-магазин балла", //
        "hotproduct" : "Горячие товары", //
        "allproduct" : "Все товары", //
        "no_more" : "Не был больше товаров", //
        "score" : "Балл", //
    },
    message:{
        "header" : "Центр  новостей", //
        "order" : "Сообщение о заказе", //
        "notice" : "Сообщение о уведомлении", //
        "empty" : "Пока нет сообщений", //
        "no_message" : "У вас нет сообщений еще", //
    },
    order:{
        "header" : "Мой заказ", //
        "empty" : "Заказ еще является пустым", //
        "gohome" : "Просто гулять ", //
        "copy" : "Копия", //
        "all" : "Весь", //
        "created" : "Платеж ожидания", //
        "paid" : "Поставка ожидания", //
        "status_cancelled" : "Отменял", //
        "back_info": "Информация о переводе", //转账信息
        "status_finished" : "Кончило", //
        "status_deliveried" : "Оценка в ожидании", //
        "status_delivering" : "В доставке", //
        "nav_delivering" : "Доставка  ожидания", //
        "nav_deliveried" : "Оценка в ожидании", //
        "comment_3" : "Хорошая оценка", //
        "comment_2" : "Средняя оценка", //
        "comment_1" : "Плохая оценка", //
        "sn" : "Номер заказа", //
        "total" : "Всего:", //
        "total_price" : "Всего", //
        "product" : "Товар шт.", //
        "shipping_price" : "С фрахтом ", //
        "btn_cancel" : "Отмена заказа", //
        "cancels" : "Отмена", //
        "cancels_finish" : "Завершение", //
        "go_payment" : "Идти в платеж", //
        "btn_track" : "Просмотр логистики", //
        "btn_confirm" : "доставку", //
        "btn_comment" : "Поделиться заказом оценки", //
        "no_want" : "Не хочу купить", //
        "no_payment" : "Неудачный платеж", //
        "no_price" : "Дороже по цене ", //
        "no_store" : "Недостатка товаров", //
        "long_wait" : "Ждать слишком долго", //
        "confirm_title" : "доставку", //
        "confirm_content" : "Подтверждаете доставки?", //
        "cancel_reason_empty" : "Выберите причину отмены", //
        "detail_header" : "Подробность заказа", //
        "detail_status_0" : "Платеж ожидания", //
        "detail_status_1" : "Поставка ожидания", //
        "detail_status_2" : "В доставке", //
        "detail_status_3" : "Оценка в ожидании", //
        "detail_status_4" : "Кончило", //
        "detail_status_5" : "Отменял", //
        "detail_status_6" : "В подборе товаров", //
        "detail_score" : "Балл", //
        "detail_more" : "Еще есть", //
        "piece" : "шт.", //
        "add_time" : "Время заказа", //
        "is_exchange_good_pay" : "Способ платежа：обмен балла", //
        "payment" : "Способ платежа", //
        "shipping" : "Способ доставки", //
        "product_price" : "Общая сумма товара", //
        "tax_price" : "Ставка налога чека", //
        "detail_shipping_price" : "Фрахт", //
        "detail_total_price" : "Фактический платеж", //
        "copy_succed" : "Копировать успешно", //
        "no_shipping_price" : "Бесплатный фрахт", //
        "track_header" : "Прослеживание заказа", //
        "track_vendor_name" : "Источник доставки", //
        "trade_header" : "Успешная сделка", //
        "trade_succed" : "Успешная сделка, продавец будет получить платеж!", //
        "go_comment" : "Немедленная оценка ", //
        "go_detail" : "Подробность заказа", //
        "check_detail" : "Просмотр заказа", //
        "comment_header" : "Товар оценки", //
        "comment_submit" : "Выдача", //
        "comment_content" : "Введите оценку здесь", //
        "comment_content_empty" : "Оцените товар", //
        "comment_succed" : "Успешная оценка", //
        "comment_succed_tips" : "Оценка товара прошла успешно, спасибо за оценку.", //
        "comment_gohome" : "Еще гулять по магазину", //
    },
    product:{
        "sort_default" : "Комплексное размещение", //
        "sort_price_asc" : "Цена от низкой до высокой", //
        "sort_price_desc" : "Цена от высокой до низкой", //
        "sort_credit_desc" : "Процент признания", //
        "sort_sale_desc" : "продаже по", //
        "sort_date_desc" : "Новые", //
        "product_tab" : "Товар", //商品
        "detail_tab" : "Подробность", //详情
        "evaluate_tab" : "Оценка", //评价
		"parameter_tab": 'стандарт', //规格参数
        "recom_tab" : "Конфигурация",
        "packing_tab" : "упаковочная ведомость",
        "keyword_placeholder" : "Введите товар вашего поиска", //
        "keyword_empty" : "Введите ключевое слово вашего поиска", //
        "sold_out" : "Распродало", //
        "only_left" : "Осталось только", //
        "piece" : "шт.", //件
        "self_support" : "Самостоятельная операция", //
        "review_rate" : "Хорошая оценка", //
        "sales_count" : "Оборот по продаже", //
        "add_cart_succ" : "Присоединился успешно", //
        "empty" : "Пока нет любых товаров", //
        "no_more" : "Не был больше",
    },
    product_detail:{
        "total" : "Весь", //
        "good" : "Хорошая оценка", //
        "medium" : "Средняя оценка", //
        "bad" : "Плохая оценка", //
        "review" : "Оценка", //评价
        "add_cart" : "Добавить в корзину", //加入购物车
        "fastbuy" : "Немедленная покупка", //立即购买
        "exchange" : "Немедленный обмен", //立即兑换
        "not_stock" : "Товар выбора пока отсутствует, извините!", //所选产品暂时无货，非常抱歉！
        "not_enough_score" : "Недостаток балла", //积分不足
        "sure" : "Определять", //确定
        "properties_empty" : "Выберите атрибут товара", //
        "not_enough_stock" : "Складские запасы данного товара не хватают", //
        "exchange_title" : "Обмен подтверждения", //
        "exchange_message_1" : "Использовать ли", //
        "exchange_message_2" : "Обмен балла", //
        "cancel_btn" : "Отмена", //取消
        "confirm_btn" : "Подтверждение", //确认
        "wechat_config_title" : "Подробность товара", //商品详情
        "score" : "Балл", //积分
        "在庫" : "Складские запасы", //库存
        "数量" : "Количество", //数量
        "max_number" : "Товар достигает лимита покупки на заказ", //
        "no_reduce" : "Хоть святых выноси, товар нельзя более меньше", //
        "no_desc" : "Пока нет деталей данного товара", //本商品暂无详情
        "infobuy_number_select" : "Выберите купить", //请选择购买
        "infobuy_number" : "Классификация числа", //数量分类
        "infobuy_selectd" : "Выбранный", //已选
        "infobuy_number_selectd" : "Выбранное число", //已选数量
        "concat" : "обслуживанием клиентов", //联系客服
        "current_day" : "В тот же день", //当天
        "next_day" : "Следующий день", //次日
        "month" : "Месяц", //月
        "day" : "День", //日
        "like" : "Палец вверх", //点赞
        "promos_time_title" : "Время до окончания деятельности", //距离活动结束时间
        "day_1" : "День", //天
        "hour" : "Час", //时
        "minute" : "Минут", //分
        "second" : "Секунд", //秒
        "promos_info_title" : "Информация о продвижении", //促销信息
        "info_header" : "Подробность товара", //商品详情
        "review_content_empty" : "Нет информации о оценке", //无评价信息
        "review_empty" : "Пока нет оценки данного товара", //本商品暂无评价
        "recommend_show_all" : "Просмотр всех", //查看全部
        "suit_goods_selected_empty" : "Выберите все атрибуты товара выбора!",
        "parameter" : "Параметр",
    },
    profile:{
        "score" : "Балл", //积分
        "record_list" : "Запись балла", //积分记录
        "order_header" : "Мой заказ", //我的订单
        "order_all" : "Просмотр полного заказа", //查看全部订单
        "order_status_0" : "Платеж ожидания", //待付款
        "order_status_1" : "Поставка ожидания", //待发货
        "order_status_2" : "Доставка  ожидания", //待收货
        "order_status_3" : "Завершение", //完成
        "favourite_header" : "Мое хранение", //我的收藏
        "address_header" : "Управление адресом доставки", //管理收货地址
        "cashgift_header" : "Мой Купон", //我的红包
        "addcashgift_header" : "Добавление Купон", //添加红包
        "bonus_header" : "Моя рекомендация", //我的推荐
        "balance_header" : "Мои средства", //我的资金
        "help_header" : "Используйте помощь", //使用帮助
        "bonus_qr_header" : "Мой двухмерный код продвижения", //我的推广二维码
        "nickname_title" : "Логин / Регистрация", //登录/注册
        "setting_header" : "Установка", //设置
        "about" : "О нас", //关于我们
        "contact" : "Связаться с нами",
        "Payment" : "Руководство по оплате",
        "help" : "Помощь заказа",
        "Postsale" : "Описание обслуживания после продажи",
        "warranty" : "Политика гарантийного ремонта",
        "signout" : "Выход логина", //退出登录
        "signout_confirm" : "Выход подтверждения", //确认退出
        "info_header" : "Личные данные", //个人资料
        "edit_nickname" : "Псевдоним изменения", //修改昵称
        "gender" : "Пол", //性别
        "edit_pwd" : "Пароль смены", //修改密码
        "male" : "Мужчина", //男
        "female" : "Женщина", //女
        "secret" : "Секретность", //保密
        "nickname_placeholder" : "Введите псевдоним", //请输入昵称
        "nickname_empty" : "Введите 1-25 букв как псевдоним", //
        "nickname_succ" : "Изменить псевдоним успешно", //修改昵称成功
        "oldpass_empty" : "Текущий пароль не может быть пустым", //
        "pass_less" : "Введите пароль из 6-20 знаков", //
        "newpass_empty" : "Новый пароль не может быть пустым", //
        "confirpass_empty" : "Введите пароль подтверждения", //
        "confirpass_false" : "Пароль подтверждения не соответствует паролю входа", //
        "btn_save" : "Сохранить", //保存
        "add_header" : "Совершенный данный", //
        "skip" : "Перескок", //跳过
        "add_tips" : "[*] пункт обязательного заполнения", //
        "add_submit" : "Завершение", //
        "placeholder" : "Заполните", //
        "add_succ" : "Улучшить информацию успешно", //
        "product_empty" : "Пока нет товаров", //
        "gohome" : "Просто гулять ", //
        "not_stock" : "Товар отсутствует", //
        "only_left" : "Осталось только", //
        "piece" : "шт.", //
        "delete" : "Удаление", //
        "confirm_del_title" : "Удаление подтверждения", //
        "confirm_del_mess" : "Хотите ли удалить товар?", //
        "share" : "Разделение", //
        "share_refresh" : "Обновление", //
        "share_to" : "Поделиться на", //
        "share_wechat" : "WeChat", //
        "share_blog" : "微博", //
        "share_qq" : "QQ", //
        "share_cancel" : "Отмена", //
        "change_avatar" : "Снимок головы смены", //
        "change_avatar_placeholder" : "Выберите снимок головы", //
        "upload" : "Загрузка...", //
        "image_type" : "Тип фотоснимка является одном из .gif, jpeg, jpg, png, bmp", //
    },
    recommend:{
        "product" : "Соотнесенный товар",
        "accessory" : "Соотнесенное сочетание ",
        "no_more" : "Не больше", //没有更多了
    },
    score:{
        "header" : "Мой балл",
        "can_use" : "Настоящий располагаемый балл",
        "all" : "Весь",
        "income" : "Доход",
        "expend" : "Расход",
        "empty" : "Пока нет записи балла",
        "exchange_succ" : "Балл обменял успешно",
        "rule_header" : "Правил балла",
        "have_score" : "Балл получения",
        "expend_score" : "Балл оплаты",
        "item_score" : "Балл",
        "platform" : "Применимая платформа",
        "to_exchange" : "Немедленный обмен",
        "confirm_use" : "Подтвердите",
        "exchange_score" : "Балл，что хотите обменять",
        "coupon" : "доллар купон баллами?",
        "confirm_btn" : "Подтверждение",
		"tip_message" : 'Балл, который вскоре переводит на счет, начисляется автоматически в общие баллы после успешной оплаты!',
		"tip_btn_text" : "Знал",
    },
    search:{
        "header" : "Последний поиск",
        "hot_header" : "Горячий поиск",
        "placeholder" : "Введите товар вашего поиска",
        "cancel" : "Отмена",
        "keyword_empty" : "Введите ключевое слово вашего поиска",
    },
}



// WEBPACK FOOTER //
// ./src/assets/i18n/ru_ru.js